import React from 'react'

const Manual_canjear_regalos_cupones_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Cómo canjear regalos/cupones desde el e-commerce
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Descubre cómo los clientes pueden canjear regalos o cupones disponibles en el e-commerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_canjear_regaloscupones_desde_el_e-commerce__8VqXom3tQnuOdsboUECxkg?as=scrollable"
          className="scribe-iframe-general-140"
          width="100%"
          height="3000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_canjear_regalos_cupones_ecommerce
